import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWineRestaurant = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "wine-restaurant" }),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: .75,
			y1: 8.625,
			x2: .75,
			y2: 19.125
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M.75,14.625h3a1.5,1.5,0,0,1,1.5,1.5v3"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 23.25,
			y1: 8.625,
			x2: 23.25,
			y2: 19.125
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M23.25,14.625h-3a1.5,1.5,0,0,0-1.5,1.5v3"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6.75,
			y1: 10.125,
			x2: 17.25,
			y2: 10.125
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 12,
			y1: 10.125,
			x2: 12,
			y2: 19.125
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 9.75,
			y1: 19.125,
			x2: 14.25,
			y2: 19.125
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M17.25,4.875a2.25,2.25,0,0,1-4.5,0Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 15,
			y1: 7.125,
			x2: 15,
			y2: 10.125
		})
	]
});
export default SvgWineRestaurant;
